export default function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}


//////////////////
// WEBPACK FOOTER
// /Users/benchmark/Sites/thomsonbiketours/wp-content/themes/thomson/node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
// module id = 20
// module chunks = 0